export default __webpack_public_path__ + "static/media/010_home.vp9.1d102940.webm";